import { UserModalConfig } from "components/UserModal";

export const INITIAL_MODAL_CONFIG: UserModalConfig = {
  onClickOutside: () => {
    return;
  },
  subtitle: "完了しました",
  main: {
    buttonType: "secondary",
    onClick: () => {
      return;
    },
    label: "閉じる",
  },
};

export const DELETE_MODAL_CONFIG = ({
  positive,
  negative,
}: {
  positive: () => void;
  negative: () => void;
}): UserModalConfig => ({
  onClickOutside: negative,
  subtitle: "削除しますか？",
  main: {
    buttonType: "primary",
    onClick: positive,
    label: "削除する",
  },
  sub: {
    label: "閉じる",
    buttonType: "secondary",
    onClick: negative,
  },
});

export const SUCCEED_MODAL_CONFIG = ({
  onClose,
  message,
}: {
  onClose: () => void;
  message: string;
}): UserModalConfig => {
  return {
    onClickOutside: onClose,
    subtitle: message,
    main: {
      buttonType: "secondary",
      onClick: onClose,
      label: "閉じる",
    },
  };
};

export const FAILED_MODAL_CONFIG = ({
  onClose,
  message = "時間をおいてもう一度お試しください",
}: {
  onClose: () => void;
  message?: string;
}): UserModalConfig => {
  return {
    onClickOutside: onClose,
    subtitle: "送信に失敗しました",
    main: {
      buttonType: "secondary",
      onClick: onClose,
      label: "閉じる",
    },
    errorMessage: message,
  };
};

export const CONFIRM_MODAL_CONFIG = ({
  negative,
  positive,
  message = "送信しますか?",
}: {
  negative: () => void;
  positive: () => void;
  message?: string;
}): UserModalConfig => {
  return {
    onClickOutside: negative,
    subtitle: message,
    main: {
      buttonType: "primary",
      onClick: positive,
      label: "はい",
    },
    sub: {
      buttonType: "secondary",
      onClick: negative,
      label: "いいえ",
    },
  };
};
